// Área "Discadora (teste)" — integração CRM → discadora (03/11/2026).
// Só a conta de teste BotConversa (grupo 9175, logins @goodata). O serviço discadora-crm
// (/api/discadora/*) repete a mesma lista e recusa qualquer outro grupo.
export const DISCADORA_GRUPOS = ["9175"];

export const canViewDiscadora = (): boolean => DISCADORA_GRUPOS.includes(localStorage.getItem("id_grupo") || "");
